import {Component, Input, Output, OnChanges, OnInit, SimpleChange, SimpleChanges, EventEmitter} from '@angular/core';
import {CompanyModel} from '../../../../../DataModels/company-model';
import {LocationModel} from '../../../../../DataModels/location-model';
import {DataService} from '../../../../../Services/data.service';
import {BankModel} from '../../../../../DataModels/bank-model';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {ItemQuantityModel} from '../../../../../DataModels/item-quantity-model';
import {NotificationService} from '../../../../../Services/notification.service';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
  selector: 'app-modal-new-item-quantity',
  templateUrl: './modal-new-item-quantity.component.html',
  styleUrls: ['./modal-new-item-quantity.component.css'],
  standalone: false
})
export class ModalNewItemQuantityComponent implements OnInit, OnChanges {
  @Input() itemID: string;
  @Input() itemQuantityID: string;
  @Output('parentReloadData') parentReloadData: EventEmitter<any> = new EventEmitter();
  companies$: CompanyModel[];
  locations$: LocationModel[];

  itemQuantity: ItemQuantityModel;
  itemQuantityForm: UntypedFormGroup;
  submitted = false;

  constructor(private table: DataService,
              private formBuilder: UntypedFormBuilder,
              private notification: NotificationService) {
    this.createForm();
  }

  ngOnInit() {
    this.loadLookups();
  }

  ngOnChanges(changes: SimpleChanges) {
    const currentItem: SimpleChange = changes.itemQuantityID;
    // console.log('prev value: ', currentItem.previousValue);
    // console.log('got item: ', currentItem.currentValue);
    if (this.itemQuantityID != '') {
      this.loadReorder();
    } else {
      this.itemQuantityForm.reset();
    }
    // Reset submitted flag on changes so pristine state has no errors showing
    this.submitted = false;
  }

  createForm() {
    this.itemQuantityForm = this.formBuilder.group({
      id: new UntypedFormControl(''),
      item_id: new UntypedFormControl(''),
      location_id: new UntypedFormControl('', Validators.required),
      minimum_on_hand_quantity: new UntypedFormControl('', Validators.required),
      maximum_on_hand_quantity: new UntypedFormControl('', Validators.required),
      minimum_order_quantity: new UntypedFormControl('', Validators.required),
      bin: new UntypedFormControl(''),
    });
  }

  private loadReorder() {
    this.table.getData('itemquantity', this.itemQuantityID).subscribe(result => {
        this.itemQuantity = result;
      },
      (error: HttpErrorResponse) => {
        this.notification.error($localize`:Error loading Entity Access @@errorLoadingEntityAccess:Error loading Entity Access`);
        console.log(error);
      },
      () => {
        this.itemQuantityForm.patchValue(this.itemQuantity);
      });
  }

  private loadLookups() {
    // this.companies$ = this.table.getData('company');
    // this.locations$ = this.table.getData('location');
    this.table.getApiListData('company', '?pageNumber=0&pageSize=999999').subscribe((res: any) => {
      this.companies$ = res.Data as CompanyModel[];
    });
    this.table.getApiListData('location', '?pageNumber=0&pageSize=999999').subscribe((res: any) => {
      this.locations$ = res.Data as LocationModel[];
    });
  }

  saveItemQuantity() {
    let retVal = false;
    this.submitted = true;
    // Touch all controls so validation styles can appear
    this.itemQuantityForm.markAllAsTouched();

    if (this.itemQuantityForm.invalid) {
      // Block save; red borders will be shown via template bindings
      return false;
    }

    this.itemQuantity = Object.assign({}, this.itemQuantityForm.value);
    this.itemQuantity.item_id = this.itemID;

    if (this.itemQuantityID) {
      this.table.patch('itemquantity', this.itemQuantityID, this.itemQuantity).then();
      retVal = true;
    } else {
      this.table.postWithPromise('itemquantity', this.itemQuantity).then();
      // this.notification.success($localize`:Saved @@saved:Saved`);
      retVal = true;
    }

    if (retVal) {
      this.parentReloadData.emit();
    }
    return retVal;
  }
}
